/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrdone1Inputs */

const en_qrdone1 = /** @type {(inputs: Qrdone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR code created and saved to your media library.`)
};

const de_qrdone1 = /** @type {(inputs: Qrdone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code erstellt und in deiner Mediathek gespeichert.`)
};

/**
* | output |
* | --- |
* | "QR code created and saved to your media library." |
*
* @param {Qrdone1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrdone1 = /** @type {((inputs?: Qrdone1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrdone1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrdone1(inputs)
	return de_qrdone1(inputs)
});
export { qrdone1 as "qrDone" }